import styles from './MenuItem.module.scss';
import clsx from 'clsx';
import {SoopAvatarCommon, SoopIcon} from '@soop-ui/soop-ui';
import {RouterLink} from '@/components/channel/common/RouterLink';
import {ROUTE} from '@/constants/main/route';
import {getUserLoginId} from '@/utils/main';

type icon =
  | 'icoWritePost'
  | 'icoUserManagement'
  | 'icoActivityManagement'
  | 'icoVodAdSetting';

interface MenuItemProps {
  nickname?: string;
  streamerId?: string;
  menuName?: string;
  iconName?: icon;
}

const MenuItem = ({
  streamerId = '',
  nickname = '',
  iconName = 'icoWritePost',
  menuName,
}: MenuItemProps) => {
  return (
    <div className={clsx(styles.menuItemWrapper)}>
      {streamerId && nickname && (
        <>
          <RouterLink
            name={ROUTE.CHANNEL.SERVICE.HOME}
            params={{streamerId: streamerId}}>
            <SoopAvatarCommon
              mode={'static'}
              variant={'default'}
              size={24}
              type={'button'}
              userId={streamerId}
              forceUpdate={getUserLoginId() === streamerId}
            />
          </RouterLink>
          <RouterLink
            name={ROUTE.CHANNEL.SERVICE.HOME}
            params={{streamerId: streamerId}}>
            <span className={clsx(styles.menuLabel)}>{nickname}</span>
          </RouterLink>
        </>
      )}
      {iconName && menuName && (
        <>
          <SoopIcon
            name={iconName}
            width={'24px'}
            height={'24px'}
            fill={'var(--soop-mode-fill-fillSecondary)'}
          />
          <span className={clsx(styles.menuLabel)}>{menuName}</span>
        </>
      )}
    </div>
  );
};

export default MenuItem;
